import { CoworldFrame } from "@softmax/product-ux/coworlds";
import { buildHref } from "@softmax/web-addresses";
import { creatorFooterLinks } from "./creator-addresses";

export function CreatorLoading() {
  return (
    <CoworldFrame
      footerLinks={creatorFooterLinks}
      title="Manage Coworlds"
      back={{ href: buildHref({ name: "browse" }), label: "Browse" }}
    >
      <output>Loading Coworlds…</output>
    </CoworldFrame>
  );
}
